'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.TimeWaitManager = {
  add: function add(id, cb, ms) {
    if (!Entry.timerInstances) {
      Entry.timerInstances = [];
    }
    var instance = new Entry.TimeWait(id, cb, ms);
    Entry.timerInstances.push(instance);
  },
  remove: function remove(id) {
    if (!Entry.timerInstances || Entry.timerInstances.length == 0) {
      return;
    }
    Entry.timerInstances = Entry.timerInstances.filter(function (instance) {
      if (instance.id === id) {
        return false;
      } else {
        return true;
      }
    });
  }
};
Entry.TimeWait = /*#__PURE__*/function () {
  function TimeWait(id, cb, ms) {
    (0, _classCallCheck2["default"])(this, TimeWait);
    this.id = id;
    this.cb = cb;
    this.ms = ms;
    this.startTime = performance.now();
    this.timer = setTimeout(this.callback.bind(this), ms);
  }
  return (0, _createClass2["default"])(TimeWait, [{
    key: "callback",
    value: function callback() {
      if (this.cb) {
        this.cb();
        this.destroy();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.timer) {
        this.ms = this.ms - (performance.now() - this.startTime);
        clearTimeout(this.timer);
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      this.timer = setTimeout(this.callback.bind(this), this.ms);
      this.startTime = performance.now();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      delete this.timer;
      delete this.cb;
      delete this.ms;
      delete this.startTime;
      Entry.TimeWaitManager.remove(this.id);
    }
  }]);
}();